import React from "react";
import TextTheme from "components/General/Text/TextTheme";
import OnboardingStepper from "components/Account/Onboarding/OnboardingStepper";
import UploadImage from "components/General/Form/UploadImage";
import TextArea from "components/General/Form/TextArea";
import RoundedButton from "components/General/Form/CustomButton/RoundedButton";
import "containers/Account/Onboarding/Onboarding.css";
import AxiosConfig from "axiosConfig";
import imageCompression from "browser-image-compression";

class Believer extends React.Component {
  state = {
    profilePic: "",
    about_me: "",
    favorite_thing: "",
    profilePicError: "",
  };

  componentDidMount() {
    AxiosConfig.get("profile/details/")
      .then((res) => {
        this.setState({
          profilePic: res.data.profile_pic,
          about_me: res.data.about_me,
          favorite_thing: res.data.favorite_thing,
        });
      })
      .catch();
  }

  onImageChange(event) {
    const imageFile = event.target.files[0];
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
    const fileSize = imageFile.size / 1024;
    if (fileSize > 180) {
      imageCompression(imageFile, options)
        .then((compressedFile) => {
          this.setState({
            profilePicError:
              "Uploaded image is too big in size. Image has been compressed.",
            profilePic: URL.createObjectURL(compressedFile),
            finalImage: compressedFile,
          });
        })
        .catch((error) => {
          this.setState({
            coverPicError: "Uploaded image is too big in size.",
          });
        });
    } else {
      this.setState({
        profilePic: URL.createObjectURL(imageFile),
        finalImage: imageFile,
        profilePicError: "",
      });
    }
  }

  onDataChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  createFormData() {
    let form_data = new FormData();
    if (this.state.finalImage)
      form_data.append(
        "profile_pic",
        this.state.finalImage,
        this.state.finalImage.name
      );
    form_data.append("about_me", this.state.about_me);
    form_data.append("favorite_thing", this.state.favorite_thing);
    return form_data;
  }

  onNextClicked(event) {
    event.preventDefault();
    let form_data = this.createFormData();

    return AxiosConfig.put("profile/details/", form_data, {
      headers: { "content-type": "multipart/form-data" },
    })
      .then(this.props.history.push(`/onboarding-dream`))
      .catch();
  }

  onSkipClicked(event) {
    this.props.history.push(`/onboarding-dream`);
  }

  render() {
    return (
      <div>
        <div className="onboarding_header">
          <div className="onboarding_header_text">
            <TextTheme
              message="Before we start, let's build your"
              className="text_xm text_white text_bold"
            />
            <TextTheme
              message="Personalized Social Impact Profile!"
              className="text_xm text_white text_bold"
            />
          </div>
          <div className="onboarding_header_stepper">
            <OnboardingStepper currentOnboardingStep="0" />
          </div>
        </div>
        <div className="onboarding_content">
          <div
            style={{
              width: "fit-content",
              align: "center",
              margin: "auto",
            }}
          >
            <UploadImage
              profilePic={this.state.profilePic}
              onImageChange={this.onImageChange.bind(this)}
            />
          </div>
          {this.state.profilePicError != "" ? (
            <TextTheme
              message={this.state.profilePicError}
              className="text_small text_red text-center"
            />
          ) : null}
          <div style={{ marginTop: "20px" }}>
            <TextArea
              title="About Me"
              rows="6"
              placeholder="Tell us about yourself."
              name="about_me"
              value={this.state.about_me}
              handleChange={this.onDataChange.bind(this)}
            />
          </div>
          <div style={{ marginTop: "20px" }}>
            <TextArea
              title="My favorite things are..."
              rows="6"
              placeholder="Tell us what always puts a smile on your face."
              name="favorite_thing"
              value={this.state.favorite_thing}
              handleChange={this.onDataChange.bind(this)}
            />
          </div>

          <div className="onboarding_button_options">
            <RoundedButton
              title="Skip for now, maybe later."
              buttonClassName="background_white"
              textThemeClassName="text_medium text_dark_orange"
              handleOnClick={this.onSkipClicked.bind(this)}
            />
            <RoundedButton
              title="&nbsp;&nbsp;&nbsp;Next&nbsp;&nbsp;&nbsp;"
              buttonClassName="background_dark_orange"
              textThemeClassName="text_medium text_white"
              handleOnClick={this.onNextClicked.bind(this)}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Believer;
